module.exports = __webpack_public_path__ + "img/news_01.550ca51e.jpg";